import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function CTASection() {
  return <section className="w-full py-16" style={{
    backgroundColor: 'white'
  }} data-id="element-27">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-29">
          <h3 className="font-handwritten text-3xl md:text-4xl" style={{
          color: 'var(--color-green)'
        }} data-id="element-30">
            Gib deinem Hund das Beste
          </h3>
          <p className="text-base md:text-lg max-w-xl mx-auto leading-relaxed" style={{
          color: 'var(--color-text)'
        }} data-id="element-31">
            Wenn dein Hund auch unter Verdauungsproblemen leidet, probiere das
            natürliche Futtertopping aus. Es hat Oscars Leben verändert –
            vielleicht verändert es auch das deines Hundes.
          </p>

          <div className="pt-4 pb-2" data-id="element-32">
            <CTAButton label="Hilf auch deinem Hund — natürlich & sanft" position="bottom_cta" data-id="element-33" />
            <div className="flex items-center justify-center gap-1.5 mt-4" data-id="element-34">
              <div className="flex gap-0.5" data-id="element-35">
                {[1, 2, 3, 4].map(i => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
                color: '#D4A843'
              }} data-id="element-36" />)}
                <div className="relative w-4 h-4 overflow-hidden" data-id="element-37">
                  <StarIcon className="w-4 h-4 fill-current absolute" style={{
                  color: '#D4A843',
                  clipPath: 'inset(0 50% 0 0)'
                }} data-id="element-38" />
                  <StarIcon className="w-4 h-4 absolute" style={{
                  color: '#D4C4B0'
                }} data-id="element-39" />
                </div>
              </div>
              <span className="text-sm" style={{
              color: 'var(--color-text-light)'
            }} data-id="element-40">
                4,4/5 · 876 Hundehalter haben es bewertet
              </span>
            </div>
            <p className="text-[13px] italic mt-3" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-41">
              Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
              Hunderunde-Kunden bestellen regelmäßig nach.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4" data-id="element-42">
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-43">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-44" />
              Schneller Versand
            </div>
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-45">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-46" />
              Zufriedenheitsgarantie
            </div>
            <div className="flex items-center gap-1.5 text-sm" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-47">
              <ShieldCheckIcon className="w-4 h-4" style={{
              color: 'var(--color-green)'
            }} data-id="element-48" />
              Natürliche Inhaltsstoffe
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}